import { Box, Container, Paper, Typography } from '@mui/material';
import { SCRIPTPAD_LOGO_URL, colors } from '@scriptpad/shared';

export const InvalidLinkPage = () => (
  <Box
    sx={{
      minHeight: '100vh',
      background: `radial-gradient(circle at top, ${colors.bgWash} 0%, #ffffff 60%)`,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Box sx={{ px: { xs: 3, sm: 6 }, pt: { xs: 3, sm: 4 } }}>
      <Box component="img" src={SCRIPTPAD_LOGO_URL} alt="ScriptPad" sx={{ height: 36 }} />
    </Box>
    <Container maxWidth="sm" sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper sx={{ p: { xs: 4, sm: 6 }, textAlign: 'center' }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          We can't find your onboarding link
        </Typography>
        <Typography color="text.secondary">
          Please use the personalised link in the email you received from ScriptPad. If you've lost it,
          please contact us at{' '}
          <a href="mailto:enquiries@scriptpad.health" style={{ color: colors.primary }}>
            enquiries@scriptpad.health
          </a>
          .
        </Typography>
      </Paper>
    </Container>
  </Box>
);
